export const SET_SELECTED_CAMPAIGN = 'SET_SELECTED_CAMPAIGN';
export const SET_YOURDATA = 'SET_YOURDATA';
export const SET_EMPLOYEEID = 'SET_EMPLOYEEID';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_APPOINTMENT_REGISTERED_FLAG = 'SET_APPOINTMENT_REGISTERED_FLAG';
export const SET_HAS_ACCOUNT_AT_MEP_FLAG = 'SET_HAS_ACCOUNT_AT_MEP_FLAG';
